interface BaseRule {
    applyRule: ApplyRule
    props: any
    ruleName?: string
}
enum ApplyRule {
    Always = "Always",
    FileNameStartsWith = "File name starts with",
    FileNameEndsWith = "File name ends with",
    FileNameContains = "File name contains"
    // SheetIndexIsEquals = "Sheet index is equals"
}

export { ApplyRule, BaseRule }
